var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.901,
    d: "m20.23 7.178-4.449 4.45a1.9 1.9 0 0 1-.971.52l-2.064.412.413-2.064a1.89 1.89 0 0 1 .52-.971l4.448-4.45m2.103 2.103 1.126-1.126a.95.95 0 0 0 0-1.344l-.758-.758a.95.95 0 0 0-1.345 0l-1.126 1.126m2.103 2.102-2.103-2.102"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.901,
    d: "M19.762 13.47c0 1.625-.442 4.063-1.4 5.415-.959 1.351-2.228 2.463-3.821 3.085-1.594.622-3.5.946-5.19.63-1.692-.318-3.329-1.381-4.548-2.53a8.082 8.082 0 0 1-2.387-4.208c-.336-1.594-.19-3.786.47-5.288.66-1.501 2.037-3.063 3.471-3.966 1.434-.903 3.561-1.197 5.286-1.197m-1.62 9.079v4.045"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.023,
    cy: 11.912,
    r: 0.979,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z",
    transform: "translate(.135 .469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e3403a2874ab4a0421b29665b2f0c412.svg";
export { ForwardRef as ReactComponent };